import HttpClient from '@/utils/HttpClient';
import ProjectStore from '@/store/Projects';
//import SettingsStore from '@/store/Settings';
import utils from '@/utils/formatting';
export default {
  get() {
    return HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/invoices`);
  },
  getById(id) {
    return new Promise((resolve, reject) => {
      HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/invoices/${id}`)
        .then(result => {
          result.Amount = parseFloat(result.Amount.toFixed(2));
          result.AmountChecked = result.AmountChecked ? parseFloat(result.AmountChecked.toFixed(2)) : null;
          //result.UStValue = result.UStValue.toFixed(2);
          result.RDate = utils.SQLDateToBrowserDate(result.RDate);
          result.BuergschaftCheck = result.BuergschaftCheck ? (result.BuergschaftCheck == 'true' ? true : false) : null;
          result.SkontoCheck = result.SkontoCheck && result.SkontoCheck == 'true' ? true : false;
          result.SFMCheck = result.SFMCheck ? (result.SFMCheck == 'true' ? true : false) : null;

          resolve(result);
        })
        .catch(err => reject(err));
    });
  },
  /*
  getLastByOrderId(orderId) {
    return new Promise((resolve, reject) => {
      HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/invoices/${orderId}/last`)
        .then(result => {
          result.RDate = utils.SQLDateToBrowserDate(result.RDate);
          result.BuergschaftCheck = result.BuergschaftCheck ? (result.BuergschaftCheck == 'true' ? true : false) : null;
          result.SkontoCheck = result.SkontoCheck && result.SkontoCheck == 'true' ? true : false;
          result.SFMCheck = result.SFMCheck ? (result.SFMCheck == 'true' ? true : false) : null;
          resolve(result);
        })
        .catch(err => reject(err));
    });
  },*/
  getPreviousById(id, iid) {
    return new Promise((resolve, reject) => {
      HttpClient.getAuthenticated(
        `/api/projects/${ProjectStore.activeProject.DbId}/orders/${id}/invoices/${iid}/previous`
      )
        .then(result => {
          if (result) {
            result.RDate = utils.SQLDateToBrowserDate(result.RDate);
            //result.SkontoFrist = utils.SQLDateToBrowserDate(result.SkontoFrist);
            result.BuergschaftCheck = result.BuergschaftCheck
              ? result.BuergschaftCheck == 'true'
                ? true
                : false
              : null;
            result.SkontoCheck = result.SkontoCheck && result.SkontoCheck == 'true' ? true : false;
            result.SFMCheck = result.SFMCheck ? (result.SFMCheck == 'true' ? true : false) : null;
          }
          resolve(result);
        })
        .catch(err => reject(err));
    });
  },
  getAllPreviousById(id, iid) {
    return new Promise((resolve, reject) => {
      HttpClient.getAuthenticated(
        `/api/projects/${ProjectStore.activeProject.DbId}/orders/${id}/invoices/${iid}/allprevious`
      )
        .then(result => {
          if (result) {
            result.RDate = utils.SQLDateToBrowserDate(result.RDate);
            //result.SkontoFrist = utils.SQLDateToBrowserDate(result.SkontoFrist);
            result.BuergschaftCheck = result.BuergschaftCheck
              ? result.BuergschaftCheck == 'true'
                ? true
                : false
              : null;
            result.SkontoCheck = result.SkontoCheck && result.SkontoCheck == 'true' ? true : false;
            result.SFMCheck = result.SFMCheck && result.SFMCheck == 'true' ? true : false;
          }
          resolve(result);
        })
        .catch(err => reject(err));
    });
  },
  getEGMOPastAmount(orderId) {
    return HttpClient.getAuthenticated(
      `/api/projects/${ProjectStore.activeProject.DbId}/orders/${orderId}/pastamounts`
    );
  },

  create(invoice) {
    const invoiceToPost = { ...invoice };
    invoiceToPost.BuergschaftCheck = invoice.BuergschaftCheck
      ? invoice.BuergschaftCheck == true
        ? 'true'
        : invoice.BuergschaftCheck == false
        ? 'false'
        : null
      : null;
    invoiceToPost.SFMCheck = invoice.SFMCheck
      ? invoice.SFMCheck == true
        ? 'true'
        : invoice.SFMCheck == false
        ? 'false'
        : null
      : null;
    //invoiceToPost.SFMCheck = invoice.SFMCheck == true ? 'true' : 'false';
    invoiceToPost.SkontoCheck = invoice.SkontoCheck == true ? 'true' : 'false';

    if (invoiceToPost.Amount === '') invoiceToPost.Amount = null;
    if (invoiceToPost.USt == '') invoiceToPost.USt = 0;
    if (invoiceToPost.AmountChecked == '') invoiceToPost.AmountChecked = null;
    if (invoiceToPost.UStChecked == '') invoiceToPost.UStChecked = null;
    if (invoiceToPost.EGMAmount == '') invoiceToPost.EGMAmount = null;
    if (invoiceToPost.EGMOAmount == '') invoiceToPost.EGMOAmount = null;
    if (invoiceToPost.SEBPercent == '') invoiceToPost.SEBPercent = null;
    if (invoiceToPost.SEBAmount == '') invoiceToPost.SEBAmount = null;
    if (invoiceToPost.SFMAmount == '') invoiceToPost.SFMAmount = null;
    if (invoiceToPost.SFMPercent == '') invoiceToPost.SFMPercent = null;

    return HttpClient.postAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/invoices`, {
      invoice: invoiceToPost
    });
  },
  update(invoice) {
    const invoiceToPost = { ...invoice };

    invoiceToPost.BuergschaftCheck = invoice.BuergschaftCheck == true ? 'true' : 'false';
    invoiceToPost.SFMCheck = invoice.SFMCheck == true ? 'true' : 'false';
    invoiceToPost.SkontoCheck = invoice.SkontoCheck == true ? 'true' : 'false';

    if (invoiceToPost.Amount === '') invoiceToPost.Amount = null;
    //if (invoiceToPost.USt == '') invoiceToPost.USt = null;
    if (invoiceToPost.AmountChecked === '') invoiceToPost.AmountChecked = null;
    //if (invoiceToPost.UStChecked == '') invoiceToPost.UStChecked = null;
    if (invoiceToPost.EGMAmount === '') invoiceToPost.EGMAmount = null;
    if (invoiceToPost.EGMOAmount === '') invoiceToPost.EGMOAmount = null;
    if (invoiceToPost.SEBAmount === '') invoiceToPost.SEBAmount = null;
    if (invoiceToPost.SEBPercent === '') invoiceToPost.SEBPercent = null;
    if (invoiceToPost.SFMAmount === '') invoiceToPost.SFMAmount = null;
    if (invoiceToPost.SFMPercent === '') invoiceToPost.SFMPercent = null;

    return HttpClient.updateAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/invoices/${invoice.DbId}`, {
      invoice: invoiceToPost
    });
  },
  delete(invoice) {
    return HttpClient.deleteAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/invoices/${invoice.DbId}`);
  },
  getInvoiceTypes() {
    return HttpClient.getAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/invoices/types`);
  }
};
